import RoundButton from "features/shared/components/buttons/RoundButton";
import DateFormatter from "features/shared/components/formatters/DateFormatter";
import { ElementSize } from "features/shared/enums/elementSize";
import React, { ReactElement, useState } from "react";
import { Collapse } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import PaymentDTO from "../dtos/PaymentDTO";
import PaymentUsageDTO from "../dtos/PaymentUsageDTO";
import PaymentPrices from "./PaymentPrices";
import PaymentUsageRow from "./PaymentUsageRow";
import PaymentUsage from "./PaymentUsage";

import styles from "./payment.module.scss";
import { PaymentType } from "../enums/paymentType";
import { getPaymentDetailRoute } from "features/shared/helpers/routeHelper";

interface IProps {
  payment: PaymentDTO;
  showInvoiceTimePeriod?: boolean;
}

const Payment: React.FC<IProps> = (props) => {
  // translations
  const { t } = useTranslation(["payments\\enums\\paymentType"]);
  const tLabels = useTranslation("payments\\payments").t;

  // props
  const { payment, showInvoiceTimePeriod } = props;

  // state
  const [paymentUsageOpen, setPaymentUsageOpen] = useState(false);

  // handlers
  const paymentDetailHandler = () => {
    console.log(payment.paymentId);
  };

  const togglePaymentHandler = () => {
    let open = paymentUsageOpen;
    setPaymentUsageOpen(!open);
  };

  // helpers
  const getPaymentUsageCount = (paymentUsage?: PaymentUsageDTO[]): number => {
    if (paymentUsage) {
      return paymentUsage.length;
    } else {
      return 0;
    }
  };

  // sub renders
  const renderButton = (paymentUsageCount: number, paymentId: string, paymentType: PaymentType): ReactElement => {
    if (paymentUsageCount > 1) {
      return (
        <RoundButton
          onClickHandler={togglePaymentHandler}
          icon="chevron-down"
          size={ElementSize.SM}
        />
      );
    } else {
      return (
        <RoundButton asLink to={getPaymentDetailRoute(paymentType, paymentId)} />
      );
    }
  };

  const renderUsegeRows = (
    paymentUsage: PaymentUsageDTO[],
    paymentId: string,
    paymentType: PaymentType
  ): ReactElement | undefined => {
    let paymentUsageCount = getPaymentUsageCount(paymentUsage);

    if (paymentUsageCount > 1) {
      return (
        <Collapse in={paymentUsageOpen}>
          <div>
            {paymentUsage?.map((item, index) =>
              <PaymentUsageRow 
                paymentUsage={item} 
                paymentId={paymentId} 
                paymentType={paymentType}
                showInvoiceTimePeriod={showInvoiceTimePeriod}
                key={index} 
              />
            )}
          </div>
        </Collapse>
      );
    }
  };

  // render
  return (
    <>
      <div className="row align-items-center no-gutters">
        <div className="col">
          <div className="row align-items-center no-gutters">
            <div className="col-auto col-sm-1 pr-sm-2">
              <div className="d-flex flex-sm-column align-items-center">
                <span className={styles.paymentDate}>
                  <DateFormatter date={payment.paymentDate!} />
                </span>
                <span className="mx-2 small text-muted d-sm-none">|</span>
              </div>
            </div>
            <div className="d-none d-sm-block col-3 pl-2">
              {payment.paymentType !== "FinancialSettlement" &&
                <div className="small text-truncate">
                  <span className="text-muted mr-1">{tLabels("payment.variableSymbol")}</span>
                  <span>{payment.variableSymbol}</span>
                </div>
              }
              <div className="small text-truncate">
                <span className="text-muted mr-1">
                  {t(`${payment.paymentType}.short`).toUpperCase()}
                  {`${[PaymentType.Bankstatement, PaymentType.Sipo].includes(payment.paymentType!) ? ":" : ""}`}
                </span>
                <span>{payment.accountCustomer}</span>
              </div>
            </div>
            <div className="col col-sm-3 pl-sm-3">
              <PaymentPrices
                amount={payment.amount!}
                currency={payment.currency!}
                paymentUsage={payment.paymentUsage ?? []}
              />
            </div>
            <div className="col-12 col-sm-5 pl-sm-2 pl-xl-4">
              <PaymentUsage 
                paymentUsage={payment.paymentUsage!} 
                showInvoiceTimePeriod={showInvoiceTimePeriod} 
              />
            </div>
          </div>
        </div>
        <div className="col-auto pl-2">
          {renderButton(getPaymentUsageCount(payment.paymentUsage), payment.paymentId!, payment.paymentType!)}
        </div>
      </div>
      {renderUsegeRows(payment.paymentUsage!, payment.paymentId!, payment.paymentType!)}
    </>
  );
};

export default Payment;